<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-card color="purple darken-2" class="text-center">
          <v-card-title class="fslt">
            <v-icon color="white" class="mr-2">mdi-gas-station</v-icon>
            <v-divider vertical class="mr-2" />
            <span>Litros no Mês:</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-9">
            <h1 class="fsl">
              {{ `LTS ${data.litersPerMonth.toFixed(2)}` }}
            </h1>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-card color="primary darken-2" class="text-center">
          <v-card-title class="fslt">
            <v-icon color="white" class="mr-2"
              >mdi-currency-usd-circle-outline</v-icon
            >
            <v-divider vertical class="mr-2" />
            <span>Valor no Mês R$:</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-9">
            <h1 class="fsl">
              {{ convertCurrentValue(data.currentMonth.toFixed(0)) }}
            </h1>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-card color="green darken-2" class="text-center">
          <v-card-title class="fslt">
            <v-icon color="white" class="mr-2"
              >mdi-currency-usd-circle-outline</v-icon
            >
            <v-divider vertical class="mr-2" />
            <span>Licitado LT:</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-9">
            <List :data="dataDashboard.licitado" color="green darken-2" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-card color="yellow darken-4" class="text-center">
          <v-card-title class="fslt">
            <v-icon color="white" class="mr-2">mdi-gas-station</v-icon>
            <v-divider vertical class="mr-2" />
            <span>Abastecido LT:</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-9">
            <List :data="dataDashboard.saidas" color="yellow darken-4" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-card color="primary" class="text-center">
          <v-card-title class="fslt">
            <v-icon color="white" class="mr-2"
              >mdi-currency-usd-circle-outline</v-icon
            >
            <v-divider vertical class="mr-2" />
            <span>Disponível LT:</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-9">
            <List :data="dataDashboard.totais" color="primary" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-card class="text-center">
          <v-card-title class="body-1"
            >COMPARATIVO DE DESPESAS ENTRE MESES</v-card-title
          >
          <v-card-text>
            <column-chart
              :data="[
                ['Mês Anterior', data.lastMonth],
                ['Mês Atual', data.currentMonth],
              ]"
            ></column-chart>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-card class="text-center">
          <v-card-title class="body-1">DESPESAS NO ANO</v-card-title>
          <v-card-text>
            <column-chart
              :dataset="chartOptions"
              :data="[
                ['Ano Atual', data.currentYear],
                ['Total Licitado', data.licitacao],
              ]"
            ></column-chart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Helpers from "@/mixins/helpers";
import List from "./components/ListCompare";
export default {
  components: { List },
  props: ["prefecture_id"],
  mixins: [Helpers],
  data: () => ({
    isCustomDashboard: false,
    dataDashboard: {
      licitado: [],
      saidas: [],
      totais: [],
    },
    data: {
      licitacao: 0,
      saidas: 0,
      total: 0,
      currentMonth: 0,
      lastMonth: 0,
      currentYear: 0,
      litersPerMonth: 0,
    },
    chartOptions: {
      backgroudColor: "blue",
    },
  }),
  created() {
    this.Helpers;
    this.initialize();
  },
  mounted() {
    this.$http(`/dashboard/prefecturesII/${this.prefecture_id}`).then(
      (r) => (this.dataDashboard = r.data)
    );
  },
  methods: {
    initialize() {
      this.$http(`/dashboard/prefectures/${this.prefecture_id}`).then(
        (r) => (this.data = r.data)
      );
    },
  },
};
</script>

<style>
</style>